import HttpClient from '../../../services/http-client';
import { serialize } from 'object-to-formdata';
import { Pagination } from '../../../../model/pagination';
import { IAccountReportAddEditRequest } from '../../../../model/sge/account-report/request/account-report-add-edit-request';
import { IAccountReportPagedRequest } from '../../../../model/sge/account-report/request/account-report-paged-request';
import { IAccountReportResponse } from '../../../../model/sge/account-report/response/account-report-response';

const basePath = (amendmentId: number) => `Amendment/${amendmentId}/AccountReports`;

const list = async (amendmentId: number, params: Omit<IAccountReportPagedRequest, 'amendmentId'>): Promise<Pagination<IAccountReportResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(amendmentId)}`,
        params
    }).then((response) => Object.assign(new Pagination<IAccountReportResponse>(), response.data));
};

const getById = async (amendmentId: number, id: number): Promise<IAccountReportResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(amendmentId)}/${id}`
    }).then((response) => response.data);
};

const add = async (amendmentId: number, params: IAccountReportAddEditRequest): Promise<void> => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: true, dotsForObjectNotation: false });
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${basePath(amendmentId)}`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

const edit = async (amendmentId: number, id: number, params: IAccountReportAddEditRequest): Promise<void> => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: true, dotsForObjectNotation: false });
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${basePath(amendmentId)}/${id}`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

const remove = async (amendmentId: number, id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${basePath(amendmentId)}/${id}`
    });
};

const AccountReportAppService = { list, getById, add, edit, remove };
export default AccountReportAppService;
